import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "icon"]

  toggle() {
    const visible = this.inputTarget.type === "password"
    this.inputTarget.type = visible ? "text" : "password"
    this.iconTarget.textContent = visible ? "visibility_off" : "visibility"
    this.buttonTarget.setAttribute("aria-label", visible ? "Hide password" : "Show password")
    this.buttonTarget.setAttribute("aria-pressed", String(visible))
  }
}
